import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminWorkspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useAcceptDeveloperAccessMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.accept(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.status(n) }), i.invalidateQueries({ queryKey: e.requests() });
		}
	});
};
//#endregion
export { i as useAcceptDeveloperAccessMutation };
